import(/* webpackMode: "eager" */ "/var/www/vhosts/conceptstudio.com/httpdocs/frontend/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/www/vhosts/conceptstudio.com/httpdocs/frontend/node_modules/nextjs-toploader/dist/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/conceptstudio.com/httpdocs/frontend/src/components/global/Header/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/conceptstudio.com/httpdocs/frontend/src/components/HighLevelComponent.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/conceptstudio.com/httpdocs/frontend/src/context/providers/LanguageProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/conceptstudio.com/httpdocs/frontend/src/context/providers/UIProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/conceptstudio.com/httpdocs/frontend/src/lib/styled-registry.js");
